import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import CreatePassword from '../views/CreatePassword.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import ChangePlan from '../views/ChangePlan.vue'
import ChangeNetwork from '../views/ChangeNetwork.vue'
import ChangePackages from '../views/ChangePackages.vue'
import UsageDetails from '../views/UsageDetails.vue'
import PaymentMethod from '../views/PaymentMethod.vue'
import Debts from '../views/Debts.vue'
import SupportTicket from '../views/SupportTicket.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true },
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresGuest: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/create-password',
    name: 'CreatePassword',
    component: CreatePassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-plan',
    name: 'ChangePlan',
    component: ChangePlan,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-network',
    name: 'ChangeNetwork',
    component: ChangeNetwork,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-packages',
    name: 'ChangePackages',
    component: ChangePackages,
    meta: { requiresAuth: true }
  },
  {
    path: '/usage',
    name: 'UsageDetails',
    component: UsageDetails,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-method',
    name: 'PaymentMethod',
    component: PaymentMethod,
    meta: { requiresAuth: true }
  },
  {
    path: '/debts',
    name: 'Debts',
    component: Debts,
    meta: { requiresAuth: true }
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: (to, from, next) => {
      localStorage.removeItem('user_token');
      localStorage.removeItem('user_token_date');
      localStorage.removeItem('user_inner_token');
      localStorage.removeItem('require_password_setup');
      next('/login');
    }
  },
  {
  path: '/support-ticket',
  name: 'SupportTicket',
  component: SupportTicket,
  meta: { requiresAuth: true }
}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, top: 80, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, left: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.query.impersonate_token) {
    localStorage.setItem('user_token', to.query.impersonate_token)
    localStorage.setItem('user_inner_token', to.query.impersonate_token)
    localStorage.setItem('user_token_date', Date.now().toString())
    const rest = { ...to.query }
    delete rest.impersonate_token
    next({ path: to.path, query: rest })
    return
  }

  const hasToken = !!localStorage.getItem('user_token')

  if (to.meta.requiresAuth && !hasToken) {
    next('/login')
    return
  }

  if (to.meta.requiresGuest && hasToken) {
    next('/')
    return
  }

  next()
})

export default router
